import moment from 'moment';
import React, { useState, useEffect } from 'react'
import { Line } from 'react-chartjs-2';
import { Maximize2 } from 'lucide-react';
import { useTranslation } from "react-i18next";

import { Card, Button } from "react-bootstrap";


const HumidityChart = ({ data, title, onSelect }) => {

  const { t } = useTranslation();

  const [state, setState] = useState(null)

  const getChartData = () => {

    let labels = []
    let dataTemp = []

    data.map(sensorData => {
      const dateTime = moment(sensorData.time); // use the full timestamp
      const hour = dateTime.format('MMM Do HH:00'); // format date as "MMM Do HH:00"
      const invalidBme = Number(sensorData.temperature) === 0 && Number(sensorData.humidity) === 0 && Number(sensorData.pressure) === 0;
      dataTemp.push(invalidBme ? null : parseFloat(sensorData.humidity).toFixed(2))
      labels.push(hour);


    })
    // Reverse both labels and dataTemp arrays
    labels.reverse();
    dataTemp.reverse();

    const state = {
      labels: labels,
      datasets: [
        {
          label: 'Humidity',
          lineTension: 0.5,
          borderWidth: 2,
          data: dataTemp,
          fill: false,
          backgroundColor: "rgba(75,192,192,0.2)",
          borderColor: "#2d40e5"
        }
      ]
    }
    setState(state)
  }

  useEffect(() => {
    getChartData()
  }, [data])

  const hasData = state && state.labels && state.labels.length > 0;

  return (
    <Card className="h-100">
      <Card.Header className="border-bottom d-flex justify-content-between">
        {title}
        <Button onClick={() => onSelect("HumidityChart")} variant="light" aria-label={t("expand_chart", { defaultValue: "Expand chart" })}>
          <Maximize2 size={20} aria-hidden="true" />
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {hasData ? <Line
          data={state}
          options={{
            plugins: {
              title: {
                display: true,
                text: 'Humidity (%)',
                fontSize: 15
              },
              legend: {
                display: true,
                position: 'bottom'
              },
            },

            scales: {
              y: {

                beginAtZero: true,
                min: 0

              }
            },
          }}
        /> : (
          <p className="text-center text-muted p-4">
            {t("no_data", { defaultValue: "No sensor history found for this period." })}
          </p>
        )}
      </Card.Body>
    </Card>
  );
}

export default HumidityChart
